import type { Translator } from '@eo-locale/core'
import type { AvailabilityTypeKeys } from './types'
import { SHIPPING_DAYS_MAP, SHIPPING_TRANSLATIONS_MAP } from "./translations"

/**
 * Returns a translated shipping availability message based on the provided availability type.
 *
 * This function maps an `availabilityType` key to both a translation key and a shipping days value,
 * then uses the provided `translate` function to generate a localized string with the number of shipping days included.
 *
 * @param translate - A translation function used to localize the message. Should match the `Translator['translate']` signature.
 * @param availabilityType - The shipping availability type used to look up the translation and shipping days.
 * @returns A localized string representing the shipping availability message, or `undefined` if no matching translation key is found.
 */
export function getShippingAvailability(translate: Translator['translate'], availabilityType: AvailabilityTypeKeys) {
  const translationKey = SHIPPING_TRANSLATIONS_MAP[availabilityType as keyof typeof SHIPPING_TRANSLATIONS_MAP] ?? ''
  const shippingDays = SHIPPING_DAYS_MAP[availabilityType as keyof typeof SHIPPING_DAYS_MAP] ?? ''

  if (!translationKey) {
    return
  }

  return translate(translationKey, {
    days: shippingDays,
  })
}

